// extracted by mini-css-extract-plugin
export var widget = "Widget-module--widget--bsnzN";
export var content = "Widget-module--content--y8cJE";